export default {"header":"_71I8cq_header","label":"_71I8cq_label",}